import React from 'react';
import { IMAGES, LINKS } from '../data/site';
const FACTS = [{
  title: 'On demand, 1–5 people',
  body: 'Contact us to arrange a small-group workshop around your experience and goals.'
}, {
  title: 'Tools and materials provided',
  body: 'Shop tools and practice material are here — bring your hands and your questions.'
}, {
  title: 'Private training',
  body: 'One-to-one sessions built around a specific project or a skill you want to sharpen.'
}];
export function WorkshopSection() {
  return <section className="bg-charcoal text-cream" aria-labelledby="workshops-heading" data-id="element-209" data-mp="kgqvicuoga32">
      <div className="mx-auto grid max-w-[1240px] gap-10 px-5 py-16 sm:px-8 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.05fr)] lg:items-center lg:gap-16 lg:py-24" data-id="element-210" data-mp="fk8pzariw7po">
        <div data-id="element-211" data-mp="6i9bap3zdfpw">
          <p className="font-display text-[13px] uppercase tracking-eyebrow text-fred" data-id="element-212" data-mp="6j28ozh1usvd">Workshops & training</p>
          <h2 id="workshops-heading" className="mt-4 font-display text-[40px] font-bold uppercase leading-[0.95] text-white sm:text-[54px]" data-id="element-213" data-mp="1j67t93nfhk1">
            Learn metal shaping
            <br data-id="element-214" data-mp="3b2109equl2xx" />
            at the workbench.
          </h2>
          <p className="mt-5 max-w-[50ch] text-[16px] leading-relaxed text-steel-200 sm:text-[17px]" data-id="element-215" data-mp="2x9umu0f2xa26">
            Build your English wheel and metal shaping skills through practical projects at our Michigan shop.
            Small-group workshops and private training focus on your experience, interests and goals.
          </p>

          <dl className="mt-8 border-t border-white/10" data-id="element-216" data-mp="3tytvvhnhmfvf">
            {FACTS.map(fact => <div key={fact.title} className="border-b border-white/10 py-4" data-id="element-217" data-mp="3g0vmyrrxrbnb">
                <dt className="font-display text-[20px] uppercase tracking-[0.03em] text-white" data-id="element-218" data-mp="3kyx5nblg98y9">
                  {fact.title}
                </dt>
                <dd className="mt-1 max-w-[52ch] text-[15px] leading-relaxed text-steel-400" data-id="element-219" data-mp="24jcdihnricgb">{fact.body}</dd>
              </div>)}
          </dl>

          <div className="mt-8 flex flex-wrap gap-3" data-id="element-220" data-mp="1pif6smbp82vq">
            <a href={LINKS.workshops} className="inline-flex min-h-[52px] items-center bg-fred px-7 font-display text-[20px] uppercase tracking-[0.06em] text-white transition-colors duration-150 ease-out hover:bg-fred-dark" data-id="element-221" data-mp="1pk01qd1xdnu4">
              Explore Workshops
            </a>
            <a href={LINKS.privateTraining} className="inline-flex min-h-[52px] items-center border border-steel-400 px-7 font-display text-[20px] uppercase tracking-[0.06em] text-white transition-colors duration-150 ease-out hover:border-cream hover:bg-white/5" data-id="element-222" data-mp="1boo683fy3tc5">
              Ask About Private Training
            </a>
          </div>
        </div>

        <div className="grid grid-cols-5 gap-4" data-id="element-223" data-mp="stzhmrci3vj5">
          <div className="col-span-5 sm:col-span-3" data-id="element-224" data-mp="2s3phzl3ms9i6">
            <img src={IMAGES.workshopWelding} alt="Gas welding a sheet metal seam at the Fournier shop" loading="lazy" width={400} height={266} className="h-[240px] w-full object-cover sm:h-[320px] lg:h-[380px]" data-id="element-225" data-mp="2s2ee7la6r1r2" />
          </div>
          <div className="col-span-5 flex flex-col justify-end gap-3 sm:col-span-2" data-id="element-226" data-mp="34eght8gjaqdy">
            <img src={IMAGES.jeffWheel} alt="Jeff Fournier standing beside an English wheel in the shop" loading="lazy" width={300} height={360} className="h-[200px] w-full object-cover object-top sm:h-[230px]" data-id="element-227" data-mp="39e33856incxu" />
            <p className="text-[13px] leading-snug text-steel-400" data-id="element-228" data-mp="2loqqivbzcmqs">
              Jeff Fournier — owner, fabricator and instructor.
            </p>
          </div>
        </div>
      </div>
    </section>;
}